const ProductCartSkeleton = () => {
  return (
    <div
      role="status"
      className="w-full animate-pulse bg-white rounded-[10px] border border-neutral-200 p-2 md:p-3  h-[368px] md:h-[573px]"
    >
      {/* Imagen */}
      <div className="flex items-center justify-center w-full h-[258px] md:w-[304px] md:h-[410px] bg-neutral-200 rounded-[10px] mb-4">
        <svg
          className="w-10 h-10 text-neutral-400"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m3 16 5-7 6 6.5m6.5 2.5L16 13l-4.286 6M14 10h.01M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z"
          />
        </svg>
      </div>

      {/* Título */}
      <div className="h-3 bg-neutral-200 rounded-full w-3/4 mb-3"></div>

      {/* Descripción */}
      <div className="h-2 bg-neutral-200 rounded-full w-full mb-2"></div>
      <div className="h-2 bg-neutral-200 rounded-full w-5/6 mb-3"></div>

      {/* Precio */}
      <div className="h-3 bg-neutral-200 rounded-full w-1/3 mb-4"></div>

      {/* Botón */}
      <div className="h-9 bg-neutral-200 rounded-[8px] w-full"></div>

      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default ProductCartSkeleton;
